import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import Sidebar from "../components/Commaon/Sidebar";
import Navbar from "../components/Commaon/Navbar";
import { canAccessPath, getDefaultAccessiblePath, getStoredUser } from "../utils/menuAccess";

const AuthLayout = () => {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const user = getStoredUser();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!canAccessPath(location.pathname, user)) {
    return <Navigate to={getDefaultAccessiblePath(user)} replace />;
  }

  return (
    <div className="d-flex">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div
        className="flex-grow-1"
        style={{ minHeight: "100vh" }}
      >
        <Navbar onToggleSidebar={() => setSidebarOpen((prev) => !prev)} style={{ position: "fixed", top: 0, left: 0, right: 0 }} />

        <div
          className="container-fluid p-3 outlet-container overflow-hidden"
          style={{
            maxWidth: "83%",
            marginTop: "12vh",
            marginLeft: "0",
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
